<template>
  <v-card flat class="rounded-lg">
    <v-card-title class="profile-card-title">سفارشات</v-card-title>
    <v-divider class="mx-4 my-0"/>

    <v-card-text>
      <v-tabs v-model="tab" grow>
        <v-tab>سفارش های باز (0)</v-tab>
        <v-tab>سفارش های بسته شده (0)</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat width="100%" height="300" class="d-flex align-center">
            <v-card-text class="text-center">
              <v-icon large>🥲</v-icon>
              <br>
              <br>
              تا حالا سفارشی از ما نداشتی
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat width="100%" height="300" class="d-flex align-center">
            <v-card-text class="text-center">
              <v-icon large>🥲</v-icon>
              <br>
              <br>
              تا حالا سفارشی از ما نداشتی
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "profileOrders",

  data: () => ({
    tab: 0
  })
}
</script>

<style scoped lang="scss">
.profile-card-title {
  position: relative;

  &:before {
    content: '';
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 24px;
    background: dodgerblue;
    border-radius: 8px;
  }
}
</style>